import { createActionsHook } from 'src/lib/sweetState';

import { GenerationToolStore } from './GenerationToolStore';

export const useGenerationToolActions = createActionsHook(GenerationToolStore);
